import React, { useEffect } from 'react';
import HeaderAuth from '../../components/HeaderAuth/HeaderAuth';
import RegisterFeedback from '../../components/Registration/RegisterFeedback/RegisterFeedback';

const RegisterFeedbackPage = () => {
  useEffect(() => {
    document.body.removeAttribute('class');
    document.title = 'Знайдено схожий профіль | New Brain';
  }, []);

  return (
    <div>
      <HeaderAuth />
      <section className='container container--login'>
        <RegisterFeedback />
      </section>
    </div>
  );
};

export default RegisterFeedbackPage;